export const SoldStockData =[
	{
		id:"1",
		SKU: "PT001",
		Product_Name: "Lenovo IdeaPad 3",
		img: "assets/img/products/stock-img-01.png",
		Unit: "6000",
		Quantity: "100",
		Tax_Value: "$300",
		Total: "$300"
	},
	{
		id:"2",
		SKU: "PT002",
		Product_Name: "Beats Pro",
		img: "assets/img/products/stock-img-06.png",
		Unit: "10",
		Quantity: "140",
		Tax_Value: "$10",
		Total: "$1600"
	},
	{
		id:"3",
		SKU: "PT003",
		Product_Name: "Nike Jordan",
		img: "assets/img/products/stock-img-02.png",
		Unit: "08",
		Quantity: "300",
		Tax_Value: "$80",
		Total: "$880"
	},
	{
		id:"4",
		SKU: "PT004",
		Product_Name: "Apple Series 5 Watch",
		img: "assets/img/products/stock-img-03.png",
		Unit: "10",
		Quantity: "450",
		Tax_Value: "$100",
		Total: "$1200"
	},
	{
		id:"5",
		SKU: "PT005",
		Product_Name: "Amazon Echo Dot",
		img: "assets/img/products/stock-img-04.png",
		Unit: "05",
		Quantity: "320",
		Tax_Value: "$400",
		Total: "$400"
	},
	{
		id:"6",
		SKU: "PT006",
		Product_Name: "Sanford Chair Sofa",
		img: "assets/img/products/stock-img-05.png",
		Unit: "07",
		Quantity: "650",
		Tax_Value: "$220",
		Total: "$2240"
	},
	{
		id:"7",
		SKU: "PT007",
		Product_Name: "Red Premium Satchel",
		img: "assets/img/products/expire-product-01.png",
		Unit: "15",
		Quantity: "700",
		Tax_Value: "$90",
		Total: "$900"
	},
	{
		id:"8",
		SKU: "PT008",
		Product_Name: "Iphone 14 Pro",
		img: "assets/img/products/expire-product-02.png",
		Unit: "12",
		Quantity: "630",
		Tax_Value: "$680",
		Total: "$6480"
	},
	{
		id:"9",
		SKU: "PT009",
		Product_Name: "Gaming Chair",
		img: "assets/img/products/expire-product-03.png",
		Unit: "10",
		Quantity: "410",
		Tax_Value: "$200",
		Total: "$2000"
	},
	{
		id:"10",
		SKU: "PT010",
		Product_Name: "Borealis Backpack",
		img: "assets/img/products/expire-product-04.png",
		Unit: "20",
		Quantity: "550",
		Tax_Value: "$400",
		Total: "$900"
	}
]